import {
  chakra,
  FormControl,
  forwardRef,
  FormHelperText,
  FormControlProps,
  FormErrorMessage,
} from '@chakra-ui/react';
import {
  FormErrorMessagePropsWithTestId,
  FormLabelPropsWithTestId,
  HelpTextPropsWithTestId,
} from 'types/general.types';
import { getContentEditableStyle } from './style';

export interface EditableContentFieldProps extends FormControlProps {
  label?: string;
  placeholder?: string;
  helperText?: string;
  errorMessage?: string;

  labelProps?: FormLabelPropsWithTestId;
  helperTextProps?: HelpTextPropsWithTestId;
  errorMessageProps?: FormErrorMessagePropsWithTestId;
}

export const EditableContentField = forwardRef<
  EditableContentFieldProps,
  'div'
>((props, ref) => {
  const {
    label,
    placeholder,
    helperText,
    errorMessage,
    labelProps,
    helperTextProps,
    errorMessageProps,
    // Following props are destructured because they are required
    // on FormControl element, and not on the Editable Content element.
    id,
    isRequired,
    isDisabled,
    isInvalid,
    isReadOnly,
    ...rest
  } = props;
  const styles = getContentEditableStyle({
    isInvalid,
    placeholder,
    isDisabled,
  });

  return (
    <FormControl
      variant="floating"
      display="flex"
      flexDirection="column"
      h="unset"
      {...{ id, isRequired, isDisabled, isInvalid, isReadOnly }}
    >
      <chakra.span
        sx={styles}
        contentEditable={!isDisabled}
        role="textbox"
        placeholder={placeholder}
        {...rest}
        ref={ref}
      />
      {errorMessage && (
        <FormErrorMessage data-testid="error-text" {...errorMessageProps}>
          {errorMessage}
        </FormErrorMessage>
      )}
      {helperText && !errorMessage && (
        <FormHelperText data-testid="error-text">{helperText}</FormHelperText>
      )}
    </FormControl>
  );
});
